<template>
  <ComponentCard title="Gallery" icon="solar:gallery-wide-linear">
    <div v-if="attrs.images.length" class="grid grid-cols-2 gap-3 sm:grid-cols-3">
      <figure v-for="(image, i) in attrs.images" :key="image.src + i" class="rounded-xl bg-[#1c4848]/[0.03] p-1.5">
        <img :src="image.src" alt="" class="aspect-square w-full rounded-lg object-cover" draggable="false">
        <BlockField :model-value="image.caption" placeholder="Caption" :read-only="readOnly" input-class="text-xs text-[#1c4848]/70" @update:model-value="list.patch(i, { caption: $event })" />
        <RowActions v-if="!readOnly" class="justify-end" :first="i === 0" :last="i === attrs.images.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
      </figure>
    </div>
    <ImagePicker v-if="!readOnly" multiple :context="context" :has-image="false" @picked="add" />
    <OptionGroup v-if="!readOnly" label="Show as" :value="attrs.layout" :options="LAYOUT_OPTIONS" @pick="set({ layout: $event })" />
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import OptionGroup from '@/components/writer/views/OptionGroup.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const LAYOUT_OPTIONS = [{ value: 'swipe', label: 'Swipe' }, { value: 'mosaic', label: 'Mosaic' }];

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props, 'images');

function add(src) {
  list.add({ src, caption: '' });
}
</script>
